//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SiloRepository
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xd998C35B7900b344bbBe6555cc11576942Cf309d)
 */
export const siloRepositoryAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_siloFactory', internalType: 'address', type: 'address' },
      { name: '_tokensFactory', internalType: 'address', type: 'address' },
      { name: '_defaultMaxLTV', internalType: 'uint64', type: 'uint64' },
      {
        name: '_defaultLiquidationThreshold',
        internalType: 'uint64',
        type: 'uint64',
      },
      {
        name: '_initialBridgeAssets',
        internalType: 'address[]',
        type: 'address[]',
      },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'AssetAlreadyAdded' },
  { type: 'error', inputs: [], name: 'AssetIsNotABridge' },
  { type: 'error', inputs: [], name: 'AssetIsZero' },
  { type: 'error', inputs: [], name: 'BridgeAssetIsZero' },
  { type: 'error', inputs: [], name: 'ConfigDidNotChange' },
  { type: 'error', inputs: [], name: 'EmptyBridgeAssets' },
  { type: 'error', inputs: [], name: 'FeesDidNotChange' },
  { type: 'error', inputs: [], name: 'GlobalLimitDidNotChange' },
  { type: 'error', inputs: [], name: 'GlobalPauseDidNotChange' },
  { type: 'error', inputs: [], name: 'InterestRateModelDidNotChange' },
  { type: 'error', inputs: [], name: 'InvalidEntryFee' },
  { type: 'error', inputs: [], name: 'InvalidInterestRateModel' },
  { type: 'error', inputs: [], name: 'InvalidLTV' },
  { type: 'error', inputs: [], name: 'InvalidLiquidationThreshold' },
  { type: 'error', inputs: [], name: 'InvalidNotificationReceiver' },
  { type: 'error', inputs: [], name: 'InvalidPriceProvidersRepository' },
  { type: 'error', inputs: [], name: 'InvalidProtocolLiquidationFee' },
  { type: 'error', inputs: [], name: 'InvalidProtocolShareFee' },
  { type: 'error', inputs: [], name: 'InvalidSiloFactory' },
  { type: 'error', inputs: [], name: 'InvalidSiloRouter' },
  { type: 'error', inputs: [], name: 'InvalidSiloVersion' },
  { type: 'error', inputs: [], name: 'InvalidTokensFactory' },
  { type: 'error', inputs: [], name: 'LastBridgeAsset' },
  { type: 'error', inputs: [], name: 'LiquidationThresholdDidNotChange' },
  { type: 'error', inputs: [], name: 'ManagerDidNotChange' },
  { type: 'error', inputs: [], name: 'ManagerIsZero' },
  { type: 'error', inputs: [], name: 'MaxLiquidityDidNotChange' },
  { type: 'error', inputs: [], name: 'MaximumLTVDidNotChange' },
  { type: 'error', inputs: [], name: 'NoPriceProviderForAsset' },
  { type: 'error', inputs: [], name: 'NotificationReceiverDidNotChange' },
  { type: 'error', inputs: [], name: 'OnlyManager' },
  { type: 'error', inputs: [], name: 'OnlyOwnerOrManager' },
  { type: 'error', inputs: [], name: 'PriceProviderRepositoryDidNotChange' },
  { type: 'error', inputs: [], name: 'RouterDidNotChange' },
  { type: 'error', inputs: [], name: 'SiloAlreadyExistsForAsset' },
  { type: 'error', inputs: [], name: 'SiloAlreadyExistsForBridgeAssets' },
  { type: 'error', inputs: [], name: 'SiloDoesNotExist' },
  { type: 'error', inputs: [], name: 'SiloIsZero' },
  { type: 'error', inputs: [], name: 'SiloMaxLiquidityDidNotChange' },
  { type: 'error', inputs: [], name: 'SiloNotAllowedForBridgeAsset' },
  { type: 'error', inputs: [], name: 'SiloPauseDidNotChange' },
  { type: 'error', inputs: [], name: 'SiloVersionDoesNotExist' },
  { type: 'error', inputs: [], name: 'TokenIsNotAContract' },
  { type: 'error', inputs: [], name: 'VersionForAssetDidNotChange' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'silo', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'assetConfig',
        internalType: 'struct ISiloRepository.AssetConfig',
        type: 'tuple',
        components: [
          { name: 'maxLoanToValue', internalType: 'uint64', type: 'uint64' },
          {
            name: 'liquidationThreshold',
            internalType: 'uint64',
            type: 'uint64',
          },
          {
            name: 'interestRateModel',
            internalType: 'contract IInterestRateModel',
            type: 'address',
          },
        ],
        indexed: false,
      },
    ],
    name: 'AssetConfigUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newBridgeAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'BridgeAssetAdded',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'bridgeAssetRemoved',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'BridgeAssetRemoved',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'BridgePool',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newMaxDeposits',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'DefaultSiloMaxDepositsLimitUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newEntryFee',
        internalType: 'uint64',
        type: 'uint64',
        indexed: false,
      },
      {
        name: 'newProtocolShareFee',
        internalType: 'uint64',
        type: 'uint64',
        indexed: false,
      },
      {
        name: 'newProtocolLiquidationFee',
        internalType: 'uint64',
        type: 'uint64',
        indexed: false,
      },
    ],
    name: 'FeeUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'globalPause',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'GlobalPause',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newModel',
        internalType: 'contract IInterestRateModel',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'InterestRateModel',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newLimitedMaxLiquidityState',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'LimitedMaxLiquidityToggled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'manager',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'ManagerChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'defaultLiquidationThreshold',
        internalType: 'uint64',
        type: 'uint64',
        indexed: false,
      },
    ],
    name: 'NewDefaultLiquidationThreshold',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'defaultMaximumLTV',
        internalType: 'uint64',
        type: 'uint64',
        indexed: false,
      },
    ],
    name: 'NewDefaultMaximumLTV',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'silo', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'siloVersion',
        internalType: 'uint128',
        type: 'uint128',
        indexed: false,
      },
    ],
    name: 'NewSilo',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newIncentiveContract',
        internalType: 'contract INotificationReceiver',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'NotificationReceiverUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newPendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipPending',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newProvider',
        internalType: 'contract IPriceProvidersRepository',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'PriceProvidersRepositoryUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'factory',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'siloLatestVersion',
        internalType: 'uint128',
        type: 'uint128',
        indexed: false,
      },
      {
        name: 'siloDefaultVersion',
        internalType: 'uint128',
        type: 'uint128',
        indexed: false,
      },
    ],
    name: 'RegisterSiloVersion',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newRouter',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'RouterUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newDefaultVersion',
        internalType: 'uint128',
        type: 'uint128',
        indexed: false,
      },
    ],
    name: 'SiloDefaultVersion',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'silo', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newMaxDeposits',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'SiloMaxDepositsLimitsUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'silo',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'pauseValue',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'SiloPause',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newTokensFactory',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'TokensFactoryUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'factory',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'siloVersion',
        internalType: 'uint128',
        type: 'uint128',
        indexed: false,
      },
    ],
    name: 'UnregisterSiloVersion',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'version',
        internalType: 'uint128',
        type: 'uint128',
        indexed: false,
      },
    ],
    name: 'VersionForAsset',
  },
  {
    type: 'function',
    inputs: [],
    name: 'acceptOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_newBridgeAsset', internalType: 'address', type: 'address' },
    ],
    name: 'addBridgeAsset',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'assetConfigs',
    outputs: [
      { name: 'maxLoanToValue', internalType: 'uint64', type: 'uint64' },
      { name: 'liquidationThreshold', internalType: 'uint64', type: 'uint64' },
      {
        name: 'interestRateModel',
        internalType: 'contract IInterestRateModel',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'bridgePool',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_manager', internalType: 'address', type: 'address' }],
    name: 'changeManager',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'defaultAssetConfig',
    outputs: [
      { name: 'maxLoanToValue', internalType: 'uint64', type: 'uint64' },
      { name: 'liquidationThreshold', internalType: 'uint64', type: 'uint64' },
      {
        name: 'interestRateModel',
        internalType: 'contract IInterestRateModel',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_assetIsABridge', internalType: 'bool', type: 'bool' },
    ],
    name: 'ensureCanCreateSiloFor',
    outputs: [],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'entryFee',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'fees',
    outputs: [
      { name: 'entryFee', internalType: 'uint64', type: 'uint64' },
      { name: 'protocolShareFee', internalType: 'uint64', type: 'uint64' },
      {
        name: 'protocolLiquidationFee',
        internalType: 'uint64',
        type: 'uint64',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBridgeAssets',
    outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'getInterestRateModel',
    outputs: [
      {
        name: 'model',
        internalType: 'contract IInterestRateModel',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'getLiquidationThreshold',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'getMaxSiloDepositsValue',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'getMaximumLTV',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'getNotificationReceiver',
    outputs: [
      {
        name: '',
        internalType: 'contract INotificationReceiver',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getRemovedBridgeAssets',
    outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'getSilo',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'getVersionForAsset',
    outputs: [{ name: '', internalType: 'uint128', type: 'uint128' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'isPaused',
    outputs: [{ name: 'globalPause', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_silo', internalType: 'address', type: 'address' }],
    name: 'isSilo',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'isSiloPaused',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'manager',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'maxLiquidity',
    outputs: [
      { name: 'globalLimit', internalType: 'bool', type: 'bool' },
      { name: 'defaultMaxLiquidity', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_siloAsset', internalType: 'address', type: 'address' },
      { name: '_siloData', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'newSilo',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'pendingOwner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'priceProvidersRepository',
    outputs: [
      {
        name: '',
        internalType: 'contract IPriceProvidersRepository',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'protocolLiquidationFee',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'protocolShareFee',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_factory',
        internalType: 'contract ISiloFactory',
        type: 'address',
      },
      { name: '_isDefault', internalType: 'bool', type: 'bool' },
    ],
    name: 'registerSiloVersion',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_bridgeAssetToRemove',
        internalType: 'address',
        type: 'address',
      },
    ],
    name: 'removeBridgeAsset',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'removePendingOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_siloAsset', internalType: 'address', type: 'address' },
      { name: '_siloVersion', internalType: 'uint128', type: 'uint128' },
      { name: '_siloData', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'replaceSilo',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'router',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
      {
        name: '_assetConfig',
        internalType: 'struct ISiloRepository.AssetConfig',
        type: 'tuple',
        components: [
          { name: 'maxLoanToValue', internalType: 'uint64', type: 'uint64' },
          {
            name: 'liquidationThreshold',
            internalType: 'uint64',
            type: 'uint64',
          },
          {
            name: 'interestRateModel',
            internalType: 'contract IInterestRateModel',
            type: 'address',
          },
        ],
      },
    ],
    name: 'setAssetConfig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_defaultInterestRateModel',
        internalType: 'contract IInterestRateModel',
        type: 'address',
      },
    ],
    name: 'setDefaultInterestRateModel',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_defaultLiquidationThreshold',
        internalType: 'uint64',
        type: 'uint64',
      },
    ],
    name: 'setDefaultLiquidationThreshold',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_defaultMaxLTV', internalType: 'uint64', type: 'uint64' },
    ],
    name: 'setDefaultMaximumLTV',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_maxDeposits', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setDefaultSiloMaxDepositsLimit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_defaultVersion', internalType: 'uint128', type: 'uint128' },
    ],
    name: 'setDefaultSiloVersion',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_fees',
        internalType: 'struct ISiloRepository.Fees',
        type: 'tuple',
        components: [
          { name: 'entryFee', internalType: 'uint64', type: 'uint64' },
          { name: 'protocolShareFee', internalType: 'uint64', type: 'uint64' },
          {
            name: 'protocolLiquidationFee',
            internalType: 'uint64',
            type: 'uint64',
          },
        ],
      },
    ],
    name: 'setFees',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_globalPause', internalType: 'bool', type: 'bool' }],
    name: 'setGlobalPause',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_globalLimit', internalType: 'bool', type: 'bool' }],
    name: 'setLimitedMaxLiquidity',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'address', type: 'address' },
      {
        name: '_newNotificationReceiver',
        internalType: 'contract INotificationReceiver',
        type: 'address',
      },
    ],
    name: 'setNotificationReceiver',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_repository',
        internalType: 'contract IPriceProvidersRepository',
        type: 'address',
      },
    ],
    name: 'setPriceProvidersRepository',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_router', internalType: 'address', type: 'address' }],
    name: 'setRouter',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_maxDeposits', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setSiloMaxDepositsLimit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_pauseValue', internalType: 'bool', type: 'bool' },
    ],
    name: 'setSiloPause',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_tokensFactory', internalType: 'address', type: 'address' },
    ],
    name: 'setTokensFactory',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_siloAsset', internalType: 'address', type: 'address' },
      { name: '_version', internalType: 'uint128', type: 'uint128' },
    ],
    name: 'setVersionForAsset',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    name: 'siloFactory',
    outputs: [
      { name: '', internalType: 'contract ISiloFactory', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'siloRepositoryPing',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'siloReverse',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'siloVersion',
    outputs: [
      { name: 'byDefault', internalType: 'uint128', type: 'uint128' },
      { name: 'latest', internalType: 'uint128', type: 'uint128' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'tokensFactory',
    outputs: [
      { name: '', internalType: 'contract ITokensFactory', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newPendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'transferPendingOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_siloVersion', internalType: 'uint128', type: 'uint128' },
    ],
    name: 'unregisterSiloVersion',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xd998C35B7900b344bbBe6555cc11576942Cf309d)
 */
export const siloRepositoryAddress = {
  1: '0xd998C35B7900b344bbBe6555cc11576942Cf309d',
} as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xd998C35B7900b344bbBe6555cc11576942Cf309d)
 */
export const siloRepositoryConfig = {
  address: siloRepositoryAddress,
  abi: siloRepositoryAbi,
} as const
